import request from '../plugins/axios'

export function login (data) {
  return request({
    url: '/login',
    method: 'post',
    data
  })
}

export function logout (data) {
  return request({
    url: '/logout',
    method: 'post',
    data
  })
}
export function userCurrent (data) {
  return request({
    url: '/user/current',
    method: 'post',
    data
  })
}

export function userMenu (data) {
  return request({
    url: '/user/menu',
    method: 'post',
    data
  })
}

export function userPerms (data) {
  return request({
    url: '/user/perms',
    method: 'post',
    data
  })
}
// 待办事项-待审核
export function usercheckByUser (data) {
  return request({
    // url: '/remind/todo/list',
    url: '/activiti/checkByUser',
    method: 'post',
    data
  })
}
// 待办事项- 我参与的
export function userToDoList (data) {
  return request({
    url: '/activiti/todo/list',
    method: 'post',
    data
  })
}

// 提醒 参数 projectId
export function remindSeen (data) {
  return request({
    // url: '/remind/seen?remindId='+ data.remindId,
    url: '/remind/seen',
    method: 'post',
    data
  })
}

// 修改密码
export function userUpdatepassword (data) {
  return request({
    url: `user/updatepassword?oldPassword=${data.oldPassword}&newPassword=${data.newPassword}&reNewPassword=${data.reNewPassword}`,
    method: 'get'
  })
}
